import { Button, Typography } from "@mui/material";
import { Iconify } from "@onair/minimal-ui/iconify";
import { cn } from "@onair/utils/cn";
import dayjs from "@onair/utils/dayjs";
import { memo } from "react";

interface CardEdocProps {
	className?: string;
	data: {
		bannerUrl: string;
		title: string;
		hashtags: string[];
		publishedAt: string;
		downloadCount: number;
		fileSize: string;
		description?: string;
	};
	onClick?: () => void;
}
const CardEdoc: React.FC<CardEdocProps> = ({ className, data, onClick }) => {
	const {
		bannerUrl,
		hashtags,
		title,
		publishedAt,
		downloadCount,
		fileSize,
		description,
	} = data;
	return (
		<div className={cn("edoc-card relative group/item", className)}>
			<div className="inner-card relative h-full" onClick={onClick}>
				<img
					src={bannerUrl}
					loading="lazy"
					className="absolute left-0 top-0 w-full h-full object-cover"
				/>
				<div
					className={cn(
						"overlay absolute w-full h-full pointer-events-none opacity-0 transition-opacity",
						"bg-gradient-to-b from-black from-20% via-black via-60% to-transparent",
						"group-hover/item:opacity-100",
					)}
				/>
				<div
					className={cn("relative z-10 flex flex-col justify-between h-full")}
				>
					<div className="edoc-card__head p-6">
						<Typography
							component="h3"
							className="text-white font-semibold text-2xl line-clamp-3 leading-snug mb-4"
						>
							{title}
						</Typography>
						<div
							className={cn(
								"edoc-card__content opacity-0 transition-opacity",
								"group-hover/item:opacity-100",
							)}
						>
							<Typography
								component="p"
								className="text-white text-sm line-clamp-4 mb-4"
							>
								{description}
							</Typography>
							<Button
								variant="outlined"
								className={cn(
									"text-white border-white",
									"hover:text-black hover:bg-white",
								)}
							>
								Nhận tài liệu
							</Button>
						</div>
					</div>
					<div className="edoc__body bg-white/40 px-6 py-5 backdrop-blur-lg">
						<CardEdocTag items={hashtags} className="mb-4" />
						<CardEdocInfo
							downloadCount={downloadCount}
							publishedAt={publishedAt}
							fileSize={fileSize}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
export default memo(CardEdoc);

interface CardEdocInfoProps {
	downloadCount?: number;
	publishedAt?: string;
	fileSize?: string;
	className?: string;
}
const CardEdocInfo: React.FC<CardEdocInfoProps> = ({
	downloadCount,
	publishedAt,
	fileSize,
	className,
}) => {
	return (
		<div
			className={cn(
				"edoc-card__info text-white flex justify-between select-none",
				className,
			)}
		>
			<div className="flex items-center gap-1">
				<Iconify icon="eva:cloud-download-fill" className="w-4 h-4" />
				<span className="text-xs">{`${downloadCount} lượt tải`}</span>
			</div>
			<div className="flex items-center gap-1">
				<Iconify icon="solar:calendar-date-bold" className="w-4 h-4" />
				<span className="text-xs">
					{dayjs(publishedAt).format("DD [tháng] M, YYYY")}
				</span>
			</div>
			<div className="flex items-center gap-1">
				<span className="text-xs font-bold">{fileSize}</span>
			</div>
		</div>
	);
};

interface CardEdocTagProps {
	items?: string[];
	className?: string;
}
const CardEdocTag: React.FC<CardEdocTagProps> = ({ items, className }) => {
	if (!items?.length) return;

	return (
		<div className={cn("edoc-card__tags flex items-center gap-2", className)}>
			{items.map((item, _index) => (
				<h6
					key={item}
					className="w-fit border px-2 py-1 border-white/80 rounded-lg text-white font-bold text-xs"
				>
					{`#${item}`}
				</h6>
			))}
		</div>
	);
};
